import { Box, Skeleton, Spinner, Text } from '@factorialco/deprecated-design-system'
import { range } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export const GenerateDraftLoading = () => (
  <Box position="relative">
    <Box
      position="absolute"
      height="s400"
      alignItems="center"
      width="full"
      justifyContent="center"
      padding="s24"
    >
      <Spinner />
      <Text.Normal>
        {i18n.tView('ats.job_posting_settings.description.generate_draft.loading', {
          factorial_ai: (
            <strong>
              {i18n.t('ats.job_posting_settings.description.generate_draft.factorial_ai')}
            </strong>
          ),
        })}
      </Text.Normal>
    </Box>
    <Box width="full" gap="s16">
      <Skeleton width="s120" height="s12" />
      {range(15).map((i: number) => (
        <Skeleton key={i} width={'full'} height="s12" />
      ))}
      <Skeleton width="s96" height="s12" />
    </Box>
  </Box>
)
